import { useConfig } from '@/composables';

const remoteHazardAssetsUrl = useConfig().value.remoteHazardAssets.iconAssetsPathSvg;

export const CENTRE_HAZARD_ICONS = {
  'ew-evacuation-centre': `${remoteHazardAssetsUrl}/ew-evacuation-centre.svg?url`,
  'ew-respite-centre': `${remoteHazardAssetsUrl}/ew-respite-centre.svg?url`,
};
